import type { Resolver } from 'cpool-schemas';
import type { z } from 'zod';

import { LoanRequestMailStatusesTableZodDefinition } from '../tables';

type Arguments = {
    id: string;
    correlationId: string;
    position: number;
};
export const schemaLoanRequestResolver_GetLoanRequestMailStatusData = LoanRequestMailStatusesTableZodDefinition.pick({
    error: true,
    status: true,
}).nullable();

export type SchemaLoanRequestResolver_GetLoanRequestMailStatusData = z.infer<
    typeof schemaLoanRequestResolver_GetLoanRequestMailStatusData
>;

export type LoanRequestResolver_GetLoanRequestMailStatusData = Resolver<
    Arguments,
    SchemaLoanRequestResolver_GetLoanRequestMailStatusData
>;
